import React from 'react';
import { Label } from 'common/design-system/components-v2';
import { IBaseLevelInfo } from 'common/consts/levels';

export const SeverityLabel: React.FC<{ severityInfo: IBaseLevelInfo }> = ({ severityInfo }) => {
    return <Label text={severityInfo.displayText} leadingIconProps={severityInfo.iconProps} />;
};
